import React from "react";
import { formatDateTimeWithSeconds } from "../../Utils/dateFormat";

function DeliveredOrder({ session, check_delivere_detail }) {
  return (
    <>
      <div className="d-flex flex-column">
        <div className="border p-3">
          <h6>Room Name: {session?.room?.name}</h6>
          <h6>Customer Name: {session?.customer?.name}</h6>
          <h6>Mobile Number: {session?.customer?.phone_number}</h6>
        </div>
        <table className="table table-hover table-bordered  mt-4">
          <thead className="headDesigne">
            <tr>
              <th>Sr</th>
              <th>Item</th>
              <th>Qty</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {check_delivere_detail &&
              check_delivere_detail.map((item, i) => {
                if (item?.status?.id >= 4) {
                  return (
                    <tr key={item?.id}>
                      <td>{i + 1}</td>
                      <td>{item?.menu?.name}</td>
                      <td>{item?.qty}</td>
                      <td>{item?.status?.name}</td>
                      <td>{formatDateTimeWithSeconds(item?.created_at)}</td>
                    </tr>
                  );
                } else {
                  return "";
                }
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default DeliveredOrder;
